import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import ServiceCity from "@/pages/ServiceCity";
import Cities from "@/pages/Cities";
import CityDetail from "@/pages/CityDetail";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Coverage from "@/pages/Coverage";
import Contact from "@/pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="services/:slug" element={<ServiceDetail />} />
          <Route path="services/:serviceSlug/:citySlug" element={<ServiceCity />} />
          <Route path="cities" element={<Cities />} />
          <Route path="cities/:slug" element={<CityDetail />} />
          <Route path="about" element={<About />} />
          <Route path="journal" element={<Blog />} />
          <Route path="journal/:slug" element={<BlogPost />} />
          <Route path="coverage" element={<Coverage />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
